const module = { name: 'movie/shared/desktop/movieRatingsTabs', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_movieReviews_dtmData } from 'require-core';

const { movieReviews, dtmData } = Fandango_movieReviews_dtmData;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_util as util } from 'require-global';



const { pageName, reviewsType } = readPageContext(movieReviews, dtmData)


const Selectors = {
    AUDIENCE_REVIEWS: '.js-rt-audience-reviews',
    CRITIC_REVIEWS: '.js-rt-critic-reviews',
    HEADER_TITLE: '.js-movie-info-title',
    PAGE_TITLE: '#page-title',
    REVIEWS_WRAP: '.js-rt-movie-reviews-wrap',
    TAB: '.js-movieRatingsTabs-tab',
    TOGGLE: '.js-movieRatingsTabs-link',
    WRAP: '#movieRatingTabWrap'
}


const Styles = {
    SELECTED_TAB: 'movie-info-tabs__tab--is-selected',
    HIDE: 'hide',
    SPINNER: 'csspinner'
}


const ReviewsTypes = {
    CRITIC: 'critic',
    MOVIE: 'movie',
}


const RegExes = {
    DTM_TYPE: /\|\s+(fan|critics)\s+\|/
}


const Attributes = {
    CHECKED: 'aria-checked'
}


let lastReviewType
function readPageContext(movieReviews, dtmData) {
    return {
        pageName: dtmData && dtmData.pageName,
        reviewsType: movieReviews && movieReviews.reviewsType
    };
}
function toggleSpinner(show) {
    if (show) {
        document.querySelector(Selectors.REVIEWS_WRAP).classList.toggle(Styles.SPINNER, show);
        return;
    }
    setTimeout(() => document.querySelector(Selectors.REVIEWS_WRAP).classList.toggle(Styles.SPINNER, show), 100);
}
function toggleReviews(reviewType) {
    toggleSpinner(true);
    if (!reviewType) {
        reviewType = ReviewsTypes.MOVIE;
    }
    const isCritics = reviewType === ReviewsTypes.CRITIC;
    $(Selectors.AUDIENCE_REVIEWS).toggleClass(Styles.HIDE, isCritics);
    $(Selectors.CRITIC_REVIEWS).toggleClass(Styles.HIDE, !isCritics);
    $(Selectors.HEADER_TITLE).html(isCritics ? 'Critic' : 'Fan');
    $(Selectors.PAGE_TITLE).html(isCritics ? movieReviews.titleOptions.critic : movieReviews.titleOptions.fan);
    toggleSpinner(false);
}
function updateState(reviewType, href) {
    if (!window.history || !window.history.pushState) {
        return;
    }
    if (!reviewType || reviewType === lastReviewType) {
        return;
    }
    lastReviewType = reviewType;
    window.history.pushState({
        reviewType
    }, '', href);
}
function setActiveTab(reviewType) {
    const tabs = document.querySelector(Selectors.WRAP).querySelectorAll(Selectors.TAB);
    tabs.forEach((tab) => {
        const btn = tab.querySelector(Selectors.TOGGLE);
        const isSelected = btn.dataset.reviewType === reviewType;
        tab.classList.toggle(Styles.SELECTED_TAB, isSelected);
        btn.setAttribute(Attributes.CHECKED, isSelected.toString());
    });
}
function refreshAd() {
    if (!window.mps || !window.mps.refreshAds || !window.mpscall) {
        return;
    }
    window.mpscall.cat = 'reviews';
    window.mps.refreshAds();
}
function refreshDtm(reviewType) {
    if (typeof window._satellite === 'undefined') {
        return;
    }
    const type = reviewType === ReviewsTypes.CRITIC ? 'critics' : 'fan';
    dtmData.pageName = pageName ? pageName.replace(RegExes.DTM_TYPE, '| ' + type + ' |') : '';
    util.track('review page');
}
function onClick(e) {
    e.preventDefault();
    const reviewType = this.dataset.reviewType;
    if (reviewType === lastReviewType) {
        return;
    }
    movieReviews.reviewsType = reviewType;
    setActiveTab(reviewType);
    toggleReviews(reviewType);
    updateState(reviewType, this.dataset.href);
    refreshAd();
    refreshDtm(reviewType);
}
function getState(evt) {
    return history && history.state ||
        evt && evt.originalState && evt.originalState.state;
}
function onPopState(e) {
    const state = getState(e);
    if (!state || !state.reviewType) {
        return;
    }
    lastReviewType = state.reviewType;
    setActiveTab(state.reviewType);
    toggleReviews(lastReviewType);
}
function init() {
    toggleReviews(reviewsType);
    $(document.body).on('click', Selectors.TOGGLE, onClick);
    if (window.history && window.history.pushState) {
        window.addEventListener('popstate', onPopState);
    }
}
module.exports = {
    init
};
export default module.exports;